import React, { Fragment } from 'react';
import styles from './ReportsMap.module.scss';
import {
  ButtonRounded,
  GoogleMap,
  GoogleMapProps
} from 'ui-smartforce-settings';
import { MapBaseDataType } from '../../Models';
import { useMarkerClick } from '../../Hooks';

export interface ReportsMapProps extends GoogleMapProps {
  reportsWithoutCoords: MapBaseDataType[];
}

export const ReportsMap = ({
  reportsWithoutCoords,
  ...props
}: ReportsMapProps): React.ReactElement<ReportsMapProps> => {
  const { onMarkerClick } = useMarkerClick(reportsWithoutCoords);

  return (
    <Fragment>
      {reportsWithoutCoords.length > 0 && (
        <ButtonRounded
          className={styles.noCoordinatesBtn}
          icon="Gps-Off"
          label={`${reportsWithoutCoords.length} ${
            reportsWithoutCoords.length === 1 ? 'Report' : 'Reports'
          } without coordinates`}
          onClick={() => onMarkerClick('noCoords')}
        />
      )}
      <GoogleMap {...props} />
    </Fragment>
  );
};
